export default __webpack_public_path__ + "static/media/partner6.a7be8e2d.jpeg";